/**
 * UretimBaglam — modüller arası paylaşılan parça bağlamı (singleton).
 * Bir modül analiz edince yazar; diğer modül açılınca okuyup ön-doldurur → kullanıcı tekrar veri girmez.
 */
export interface UretimBaglam {
  parcaAd?: string;
  malzeme?: string;
  olcu?: string;        // "EN×BOY×YUK" mm
  netKg?: number;
  hacimCm3?: number;
  alanDm2?: number;
  delikler?: number[];  // çaplar (mm)
  guncel?: boolean;     // en az bir analiz yapıldı mı
}

export const URETIM_BAGLAM: UretimBaglam = {};

/** Bağlamı güncelle (yazan modül). */
export function baglamYaz(b: Partial<UretimBaglam>): void {
  Object.assign(URETIM_BAGLAM, b, { guncel: true });
}

/** Bağlamı oku (okuyan modül). */
export function baglamOku(): UretimBaglam {
  return URETIM_BAGLAM;
}
